import { ChevronDown, ChevronUp, Users, BellOff } from "lucide-react";
import { formatLastMessage, chatRowClasses } from "./chatUtils";

const ChatGroupList = ({
  groups,
  expanded,
  currentTeamId,
  unreadCounts,
  mutedConversations,
  onToggle,
  onSelect,
}) => {
  if (groups.length === 0) return null;

  return (
    <>
      <button
        onClick={() => onToggle("groups")}
        className="w-full flex items-center gap-x-1.5 px-2 py-1 text-[10px] uppercase tracking-wider text-zinc-400 dark:text-zinc-600 hover:text-zinc-500 dark:hover:text-zinc-500 transition-colors mt-1"
      >
        <span className="flex-1 text-left">Groups</span>
        {!expanded &&
          (() => {
            const total = groups.reduce(
              (sum, g) => sum + (unreadCounts[g.team_id] || 0),
              0,
            );
            return total > 0 ? (
              <span className="text-sky-500 text-[10px] font-medium">
                {total > 99 ? "99+" : total}
              </span>
            ) : null;
          })()}
        {expanded ? (
          <ChevronUp className="h-2.5 w-2.5 shrink-0" strokeWidth={2} />
        ) : (
          <ChevronDown className="h-2.5 w-2.5 shrink-0" strokeWidth={2} />
        )}
      </button>
      {expanded &&
        groups.map((g) => {
          const isActive = g.team_id === currentTeamId;
          const unread = unreadCounts[g.team_id] || 0;
          return (
            <div
              key={g.team_id}
              data-context-menu="team-conversation"
              data-context-payload={JSON.stringify({
                team_id: g.team_id,
                type: "group",
                name: g.name,
              })}
            >
              <button
                onClick={() => onSelect(g.team_id)}
                title={g.name}
                className={chatRowClasses(isActive)}
              >
                <Users
                  className="h-3 w-3 shrink-0 text-zinc-400"
                  strokeWidth={2}
                />
                <span className="truncate">{g.name}</span>
                {unread > 0 && (
                  <span className="ml-auto bg-sky-500 text-white text-[10px] font-medium rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 shrink-0">
                    {unread > 99 ? "99+" : unread}
                  </span>
                )}
                {unread === 0 && (
                  <span className="ml-auto flex items-center gap-x-1 shrink-0">
                    {mutedConversations.includes(g.team_id) && (
                      <BellOff
                        className="h-3 w-3 text-zinc-300 dark:text-zinc-600"
                        strokeWidth={2}
                      />
                    )}
                    {g.last_message_ts && (
                      <span className="text-[10px] text-zinc-400 dark:text-zinc-600">
                        {formatLastMessage(g.last_message_ts)}
                      </span>
                    )}
                  </span>
                )}
              </button>
            </div>
          );
        })}
    </>
  );
};

export default ChatGroupList;
